export enum ModalTypes {
  FullHeight,
  DynamicHeight,
}
